






























































import Vue from 'vue';
import OrgService from '@/api/org.service';
import StatService from '@/api/stats.service';
import { SET_ORG_DETAILS } from '@/store/mutation-types';
import { TopLevelSpec } from 'vega-lite';
import VueVegaEmbed from '@/components/Vis/Vega/VueVegaEmbed.vue';
import { LOAD_STATE } from '../../store/shared';
import { ICooldownProjection } from '../../store/types';
import { genBarSpec } from '../Vis/Vega/Specs/BarSpec';

export default Vue.extend({
  name: 'OfferRedemptionEditor',
  components: {
    VueVegaEmbed,
  },
  data() {
    return {
      // date diff (endDate is session date, startDate is date of coupon expiration of previously accepted offer)
      // if date diff is negative, it means that the discount would have been blocked with a cooldown period of that many months
      cooldownProjections: [] as ICooldownProjection[],
      cooldownProjectionsLoadState: LOAD_STATE.UNLOADED,
    };
  },
  async created() {
    await this.loadCooldownProjections();
  },
  computed: {
    discountCooldown() {
      return this.$store.state.org.discountCooldown || 0;
    },
    pauseCooldown() {
      return this.$store.state.org.pauseCooldown || 0;
    },
    cooldownsLoading(): boolean {
      return this.cooldownProjectionsLoadState !== LOAD_STATE.LOADED;
    },
    relevantCooldowns(): ICooldownProjection[] {
      return this.cooldownProjections.filter((c) => c.cooldownProjection >= 0);
    },
    preventedDiscounts(): number {
      return this.relevantCooldowns
        .filter((c) => c.cooldownProjection !== null && c.cooldownProjection < this.discountCooldown)
        .reduce((acc, c) => acc + c.count, 0);
    },
    totalAcceptedDiscounts(): number {
      return this.cooldownProjections.reduce((acc, c) => acc + c.count, 0);
    },
    totalAcceptedMultipleDiscounts(): number {
      return this.cooldownProjections.reduce((acc, c) => (c.cooldownProjection !== null ? acc + c.count : acc), 0);
    },
    multiplePct(): string {
      if (this.totalAcceptedDiscounts === 0) {
        return '0%';
      }
      return `${((this.totalAcceptedMultipleDiscounts / this.totalAcceptedDiscounts) * 100).toFixed(1)}%`;
    },
    preventedPct(): string {
      if (this.totalAcceptedMultipleDiscounts === 0) {
        return '0%';
      }
      return `${((this.preventedDiscounts / this.totalAcceptedMultipleDiscounts) * 100).toFixed(1)}%`;
    },
    chartVegaSpec(): TopLevelSpec | null {
      const data = this.relevantCooldowns.filter((d) => d.cooldownProjection !== null && d.cooldownProjection < 12);
      const chartData = data.map((d: any) => ({
        ...d,
        'Months After Expiration': d.cooldownProjection,
        Cooldown: `${d.cooldownProjection} months`,
        Projected: d.cooldownProjection < this.discountCooldown ? 'Prevented' : 'Allowed',
      }));
      if (chartData && chartData.length) {
        return genBarSpec({
          data: chartData,
          xField: 'Months After Expiration',
          yField: 'count',
          colorField: 'Projected',
          xLabels: true,
          yLabels: true,
          xSortField: 'Months After Expiration',
          yAxisTitle: 'Customers',
          xAxisTitle: 'Months of Cooldown After Discount',
          barLabels: true,
          colorScale: {
            domain: ['Prevented', 'Allowed'],
            range: ['#D8DFF6', '#3C5CCF'],
          },
          yFormat: '0',
        });
      }
      return null;
    },
  },
  methods: {
    async save() {
      if (!this.$store.getters.hasPermission('cf:write')) return;
      await OrgService.update(this.$store.state.org._id, { discountCooldown: this.discountCooldown, pauseCooldown: this.pauseCooldown });
    },
    update(body: { discountCooldown?: number; pauseCooldown?: number }) {
      this.$store.commit(SET_ORG_DETAILS, body);
      this.save();
    },
    async loadCooldownProjections() {
      this.cooldownProjectionsLoadState = LOAD_STATE.LOADING;
      const res = await StatService.getCooldownProjections();
      if (res) {
        this.cooldownProjections = res;
      }
      this.cooldownProjectionsLoadState = LOAD_STATE.LOADED;
    },
  },
});
